import { el } from '../core/dom.js';

/**
 * @param {{ id: string, label: string, selected?: boolean }[]} items
 * @param {(id: string) => void} onSelect
 */
export function tabs(items, onSelect) {
  return el('div', { class: 'tabs', role: 'tablist' }, items.map((item) => el('button', {
    type: 'button',
    class: item.selected ? 'tab is-on' : 'tab',
    role: 'tab',
    'aria-selected': item.selected ? 'true' : 'false',
    onClick: () => onSelect(item.id),
  }, item.label)));
}
